var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDenoiser = function SvgDenoiser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.057 2.43a8.26 8.26 0 0 1 2.479 11.418.75.75 0 0 0 1.261.812c2.917-4.534 1.605-10.574-2.928-13.49a.75.75 0 0 0-.812 1.26M10.2 3.623a6.02 6.02 0 0 1 4.187 10.344q-.592.573-1.487 1.362a3.83 3.83 0 0 0-1.296 2.871v.98a3.25 3.25 0 1 1-6.5 0 .75.75 0 0 0-1.5 0 4.75 4.75 0 1 0 9.5 0v-.98c0-.668.287-1.304.788-1.746a46 46 0 0 0 1.538-1.41A7.52 7.52 0 1 0 2.68 9.642a.75.75 0 1 0 1.5 0 6.02 6.02 0 0 1 6.02-6.019m-.23 8.25a2 2 0 1 1 0-4 2 2 0 0 1 0 4",
    clipRule: "evenodd"
  })));
};
export default SvgDenoiser;